import { message } from 'antd';

import { initOfferSuccessAction } from 'containers/Offers/Offer/store';

import { OfferDetails } from 'codegen';
import { IDataResponse, TRequestCallback } from 'types';

export const handleSuccessPutOfferDetails = (
  type: 'published' | 'unpublished',
) => (
  { data }: IDataResponse<OfferDetails>,
) => {
  initOfferSuccessAction(data);
  message.success(`Offer successfully ${type}!`);
};

export const handlePublishOfferRequest = (
  putPublishOffer: TRequestCallback,
) => () => {
  putPublishOffer();
};
